import { programsApi } from "./api/program.api";

/**
 * Broad(内涵)requirement 推荐课的会话级缓存,keyed by `programId::requirementId`。
 * 结果与 program 结构无关(不进 structureVersion 契约),随目录/排序变化,后端侧
 * 已按 query hash 跨用户缓存;前端只在会话内去重。登录用户的响应已减去其已有课,
 * 会话内新增课由消费方(useSuggestedCourses)按最新 userCourses 再过滤,不重拉。
 * 身份切换时须清空(排除口径随用户变),挂在 sliceCacheIdentity 的同一时机。
 */
const cache = new Map<string, string[]>();
const inflight = new Map<string, Promise<string[]>>();

export function getSuggestedCourseIds(
    programId: string,
    requirementId: string,
): Promise<string[]> {
    const key = `${programId}::${requirementId}`;
    const cached = cache.get(key);
    if (cached) return Promise.resolve(cached);
    const pending = inflight.get(key);
    if (pending) return pending;

    const request = programsApi
        .getRequirementSuggestions(programId, requirementId)
        .then(result => {
            cache.set(key, result.courseIds);
            return result.courseIds;
        })
        .finally(() => {
            inflight.delete(key);
        });
    inflight.set(key, request);
    return request;
}

/** 身份切换 / 结构失效时调用 */
export function clearSuggestions(): void {
    cache.clear();
}
